import {
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  REGISTER_USER_REQUESTED,
  VERIFY_EMAIL_REQUESTED,
  VERIFY_EMAIL_FULFILLED,
  VERIFY_EMAIL_REJECTED,
} from './types';
import get from 'lodash/get'
import axiosInstance from '../Lib/axios';

export const registerUser = (userCredentials) => (dispatch) => {
  dispatch(registerUserRequested());
  
  axiosInstance.post('auth/registration/', userCredentials)
    .then(response =>
      dispatch(registerUserFulfilled(response.data))
    )
    .catch(error => 
      dispatch(registerUserRejected(get(error, 'response.data'))))
}

function registerUserRequested() {
  return { type: REGISTER_USER_REQUESTED}
}

function registerUserFulfilled(data) {
  return { type: REGISTER_USER_FULFILLED, payload: data}
}

function registerUserRejected(error) {
  return { type: REGISTER_USER_REJECTED, payload: error}
}

export const verifyEmail = (email) => (dispatch) => {
  dispatch(verifyEmailRequested());

  axiosInstance.post('auth/registration/verify-email/', email)
    .then(response =>
      dispatch(verifyEmailFulfilled(response.data))
    )
    .catch(
      error => dispatch(verifyEmailRejected(error.response)))
}

function verifyEmailRequested() {
  return { type: VERIFY_EMAIL_REQUESTED}
}

function verifyEmailFulfilled(data) {
  return { type: VERIFY_EMAIL_FULFILLED, payload: data}
}

function verifyEmailRejected(error) {
  return { type: VERIFY_EMAIL_REJECTED, payload: error}
}
